// extracted by mini-css-extract-plugin
export default {"thank-you-create-modal":"styles__thank-you-create-modal___Aykw6","is-large-override":"styles__is-large-override___rztcH"};